import {
  normalizeFlowFilterState,
  normalizeFlowSideBasisSelection,
  type FlowSideBasis,
  type State,
} from 'utils/shared/trades/presets';
import { getTradeSidesForFlowSideBasis } from 'utils/shared/trades/flowSideBasis';

export interface SavedFlowSideSelection {
  flowSideBasis: FlowSideBasis[];
  tradeSides: string[];
}

/**
 * Derives the committed flow-side selection from a user's persisted
 * `optionFlowFilters` (jsonb on the user record). Runs the same normalization /
 * legacy migration the Command Center uses, and falls back to the normalized
 * default when there are no saved filters, so callers always get a usable value.
 */
export const getSavedFlowSideSelection = (optionFlowFilters?: unknown): SavedFlowSideSelection => {
  const normalized = normalizeFlowFilterState((optionFlowFilters as Partial<State>) ?? null);
  const flowSideBasis = normalizeFlowSideBasisSelection(normalized.flowSideBasis);

  return {
    flowSideBasis,
    tradeSides: getTradeSidesForFlowSideBasis(flowSideBasis),
  };
};
